import { Injectable, Inject, LOCALE_ID } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: "root"
})
export class DadesService {
  features: any = null;
  urlApi = window.location.protocol + '//' + window.location.hostname + '/api/InfotransitAPI.asmx/';
  alertes = ["ROADWORKS","CONGESTION","INCIDENCE","MOUNTAINPASS","METEO","CONES"];
  serveis = ["GAS_STATION","RADAR","PARKING","PARKANDRIDE","TRAMS_PERILL"]; // Nom de les capes del tipus servei

  constructor(private http: HttpClient, @Inject(LOCALE_ID) protected localeId: string) {}

  getLayer(layer: string, bounds:string) {
    
    if(this.alertes.includes(layer)) {
      var url = this.urlApi + 'GetIncidencies?' + 
              'bbox=-27.0666950941295,44.03133255621614,9.6496134996205,26.813039629431152' + //bounds +
              '&lang=' + this.localeId +
              '&outputFormat=geojson' + 
              '&incidentType=' + layer
      return this.http.get(url)   
    }
    else if(layer === "CAMERA"){
      var url = this.urlApi + 'getCameras?' + 
              'bbox=' + bounds +
              '&lang=' + this.localeId +
              '&outputFormat=geojson'
      return this.http.get(url) 
    }
    else if(this.serveis.includes(layer)){
      if(layer==="PARKING"){
        var url = this.urlApi + 'GetPoisWeb?' +
              'bbox=' + bounds +
              '&poiType=PARKING&incidentType=' + 
              '&lang=' + this.localeId +
              '&outputFormat=geojson'
        return this.http.get(url) 
      }
      else if(layer === "PARKANDRIDE"){
        var url = this.urlApi + 'GetPoisWeb?' +
              'bbox=' + bounds +
              '&poiType=PARKANDRIDE&incidentType=' + 
              '&lang=' + this.localeId +
              '&outputFormat=geojson'
        return this.http.get(url) 
      }
      else if(layer==="RADAR"){
        var url = this.urlApi + 'getRadars?' + 
              'bbox=' + bounds +
              '&lang=' + this.localeId +
              '&outputFormat=geojson'
        return this.http.get(url)
      }
      else if(layer === "GAS_STATION"){
        var url = this.urlApi + 'getGasStations?' + 
              'bbox=' + bounds +
              '&lang=' + this.localeId +
              '&outputFormat=geojson'
        return this.http.get(url)
      }
      else if(layer === "TRAMS_PERILL"){
        var url = this.urlApi + 'GetTrams?' +
                  'bbox=-27.0666950941295,44.03133255621614,9.6496134996205,26.813039629431152' + 
                  '&lang=' + this.localeId +
                  '&outputFormat=geojson';
        return this.http.get(url);
      }
    }
    
  }
}
